module.exports = __webpack_public_path__ + "media/src/assets/images/amenities_blue/body_wash-6c9a9f50cef546e10b970ff0fe1e40c6.svg";